import { useEffect } from 'react';

const usePageTitle = (title) => {
  useEffect(() => {
    const defaultTitle = "Kunal Agarwal";
    document.title = title ? `${title} | Kunal Agarwal` : defaultTitle;
    
    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = defaultTitle;
    };
  }, [title]);
};

export default usePageTitle;